import { MainLayout } from "@components/layouts/MainLayout";
import { UserPlus } from "lucide-react";
import { PageHeader } from "@components/layouts/PageHeader";
import { Sources } from "@components/players/sign-up/Sources";
import { Journey } from "@components/players/sign-up/Journey";
import { useState } from "react";
import { useApiDataWithDateRange } from "@hooks/useApiDataWithDateRange";
import { addDays } from "date-fns";
import type { DateRange } from "react-day-picker";
import { DatePickerWithRange } from "@components/ui/date-range-picker";
import { Separator } from "@components/ui/separator";

export default function SignUp() {
  const [dateRange, setDateRange] = useState<DateRange | undefined>({
    from: addDays(new Date(), -30),
    to: new Date(),
  });

  const [signupData, loading, error] = useApiDataWithDateRange(
    "/api/superone/signup-source-data",
    dateRange,
    {
      transform: (res: any) => {
        if (Array.isArray(res)) return res;
        if (res && typeof res === "object") {
          if (Array.isArray(res.signupSourceStats))
            return res.signupSourceStats;
          if (Array.isArray(res.players)) return res.players;
          if (Array.isArray(res.data)) return res.data;
          if (res.data && typeof res.data === "object") return res.data;
        }
        return {};
      },
    }
  );

  return (
    <MainLayout>
      <div className="space-y-6 p-6">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-2">
          <PageHeader
            icon={<UserPlus className="h-6 w-6 text-blue-600" />}
            title="Sign Up"
            subtitle="Player sign up sources and journey."
          />
          <div className="mt-4 md:mt-0">
            <DatePickerWithRange
              defaultRange={dateRange}
              onDateChange={setDateRange}
            />
          </div>
        </div>
        <Separator className="mb-12" />
        <div className="space-y-8">
          <div className="pt-4 pb-4">
            <Sources
              data={signupData}
              loading={loading}
              error={error}
              asTable
              startDate={dateRange?.from}
              endDate={dateRange?.to}
            />
          </div>
          {/* <div className="pt-4 pb-4">
            <Journey data={signupData} loading={loading} error={error} />
          </div> */}
        </div>
      </div>
    </MainLayout>
  );
}
